/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type CreditSummaryResponseAlertThresholdAlertType = typeof CreditSummaryResponseAlertThresholdAlertType[keyof typeof CreditSummaryResponseAlertThresholdAlertType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreditSummaryResponseAlertThresholdAlertType = {
  PERCENT: 'PERCENT',
  VALUE: 'VALUE',
} as const;
